export default __webpack_public_path__ + "474d2021f98d7a0c4afc88836b7d9b5e.svg";